import React from 'react'

const PageBreak: React.FC = () => {
    return <div style={{ pageBreakBefore: 'always' }}></div>
}

export default PageBreak
